import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

const RadioUnchecked = (props: IconSvgProps) => {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
};

export default RadioUnchecked;
